import reducers from './reducers'

export default reducers